export default __webpack_public_path__ + "static/media/icono-editar.5cca96bb.svg";